import LegalLayout from "@/components/LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Refund & Cancellation Policy" updated="20 August 2026" testId="refund-policy-page">
      <p>
        This policy explains how cancellations and refunds work for the one-time assessment fee paid on
        PathfinderAiClub. It applies to payments made through our payment partner, Cashfree.
      </p>

      <h2>1. Nature of the service</h2>
      <p>
        The assessment fee unlocks instant, ongoing access to the AI career assessment and your personalised
        report — the moment payment is confirmed, access is granted to your account. Because access is
        delivered immediately, this is treated as a digital service delivered at the point of purchase.
      </p>

      <h2>2. No refunds after purchase</h2>
      <p>
        As access is granted instantly on successful payment, we do not offer refunds or cancellations for
        change of mind, once the payment has been successfully completed and access has been unlocked.
        Please review the pricing and what's included on the payment page before completing your purchase.
      </p>

      <h2>3. Failed or duplicate payments</h2>
      <p>
        If an amount was debited from your account but your order was not marked as successful, or you were
        charged more than once for the same order, you are entitled to a full refund of the extra or failed
        charge. In most cases, failed payments are automatically reversed by Cashfree or your bank within
        5–7 business days without any action needed from you.
      </p>
      <p>
        If you don't see the reversal after 7 business days, contact us at{" "}
        <a href="mailto:support@pathfinderaiclub.com">support@pathfinderaiclub.com</a> with your order ID or
        transaction reference, and we will investigate and process a refund where applicable.
      </p>

      <h2>4. Technical errors on our end</h2>
      <p>
        If a technical issue on our platform prevents you from accessing the assessment after a successful
        payment, contact support and we will either restore access or issue a full refund, at our discretion.
      </p>

      <h2>5. Refund timelines</h2>
      <p>
        Approved refunds are issued to the original payment method used at checkout. Depending on your bank
        or card network, refunds can take 5–7 business days to reflect in your account after being processed
        on our end.
      </p>

      <h2>6. How to reach us</h2>
      <p>
        For any payment, refund, or cancellation query, email{" "}
        <a href="mailto:support@pathfinderaiclub.com">support@pathfinderaiclub.com</a> — see our{" "}
        <a href="/contact">Contact Us</a> page for details.
      </p>
    </LegalLayout>
  );
}
